import isElement from '../../scripts/util/DOM/isElement';

const selectors = {
	el: '.js-header',
	wrap: '.js-header-wrap',
	subheader: '.js-subheader'
};

const states = {
	visible: 'header__subheader_visible'
};

const getTopPos = el => {
	const pageY = window.pageYOffset;
	const top = el.getBoundingClientRect().top;
	const height = el.offsetHeight;
	const val = pageY + top + height;
	return val;
};

const toggleMenu = (previousPos, menu, wrap) => () => {
	const scrollY = window.pageYOffset;
	if (scrollY < previousPos && scrollY > getTopPos(wrap)) {
		menu.classList.add(states.visible);
	}else {
		menu.classList.remove(states.visible);
	}
	previousPos = window.pageYOffset;
};

const onScroll = () => {
	const subheader = document.querySelector(selectors.subheader);
	const wrap = document.querySelector(selectors.wrap);
	const previous = window.pageYOffset;
	window.addEventListener('scroll', toggleMenu(previous, subheader, wrap));
};

const render = () => {
	if (isElement(selectors.subheader)) {
		onScroll();
	}
};

export default render;



// WEBPACK FOOTER //
// ./app/blocks/header/index.js